import { render, staticRenderFns } from "./ControlParcelDeclaration.vue?vue&type=template&id=258cc6f3"
import script from "./ControlParcelDeclaration.vue?vue&type=script&lang=js"
export * from "./ControlParcelDeclaration.vue?vue&type=script&lang=js"
import style0 from "./ControlParcelDeclaration.vue?vue&type=style&index=0&id=258cc6f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports